import React, { Component } from 'react';
import WaveSurfer from 'wavesurfer.js';
import './styles.css'
import axios from 'axios'
import { ElasticBeanstalk } from 'aws-sdk';
import {isMobile} from 'react-device-detect';
class Waveform extends Component {  
  state = {
    playing: false,
    current : 0,
    hasStarted : false,
    pause : false
  };
  componentDidMount() {
    const track = document.querySelector(`#track${this.props.id}`);
    const volumeIcon = document.querySelector(`#volumeIcon${this.props.id}`)
    const volumeSlider = document.querySelector(`#volumeSlider${this.props.id}`)
    volumeIcon.addEventListener("click", this.toggleMute)
    volumeSlider.addEventListener("input", this.handleVolumeChange)

    this.waveform = WaveSurfer.create({

      barWidth: 3,
      cursorWidth: 1,
      container: `#waveform${this.props.id}`,
      backend: 'WebAudio',
      height:isMobile? 30:  45,
      progressColor: '#'+this.props.color,
      responsive: true,
      normalize : true,
      fillParent: true,
      waveColor: 'white',
      cursorColor: 'transparent',
    });
    this.props.send(this.waveform, this.props.id, this.pause)
    this.waveform.on('audioprocess', () => {      
        this.setState({current :this.waveform.getCurrentTime()})
    });
    console.log(track)
    try {
      this.waveform.load(track);
    }
     catch (e) {
  console.log('Wavesurfer loading failed', e)
}
    console.log(this.props.color)
    
  };
  setVolumeFromLocalStorage = () => {
    const volumeSlider = document.querySelector("#volumeSlider")
    // Retrieves the volume from local storage, or falls back to default value of 50
    const volume = localStorage.getItem("audio-player-volume") * 100 || 50
    volumeSlider.value = volume
  }
  handleVolumeChange = e => {
    // Set volume as input value divided by 100
    console.log(e.target.value)
    // NB: Wavesurfer only excepts volume value between 0 - 1
    const volume = e.target.value / 100
    this.waveform.setVolume(volume)
    // Save the value to local storage so it persists between page reloads
    localStorage.setItem("audio-player-volume", volume)
  }
  async componentWillUnmount(){
    if ( this.state.playing){

      this.waveform.playPause();
    }
  }
  toggleMute = () => {
    this.waveform.toggleMute()
    const isMuted = this.waveform.getMute()
    const volumeSlider = document.querySelector("#volumeSlider")
    if (isMuted) {
      volumeSlider.disabled = true
    } else {
      volumeSlider.disabled = false
    }
  }

  handlePlay = async () => {
    

    if (!this.state.hasStarted){
      this.setState({ hasStarted : true})
      let token = localStorage.getItem('token')
      axios.defaults.headers.common['Authorization'] = "token: "+token

          
      let response;
      
      response = await axios.post(process.env.REACT_APP_BACKEND_URL + '/play-song', {
          id : this.props.songid
      })


    }
    if (!this.state.playing){
      this.props.pause(this.props.id)
    } 
    this.setState({ playing: !this.state.playing });
    this.waveform.playPause();
  };
  pause = () => {
    this.setState({ playing: false });
    this.waveform.pause();
  }
  render() {
    const url = 'https://www.mfiles.co.uk/mp3-downloads/gs-cd-track2.mp3';

    return (
      <div style={{height  : '50px'}} >
        <button style={{marginLeft : isMobile ? '4px' : '0px'}}id="wavebtn" onClick={this.handlePlay} >
          <span style={{fontSize :isMobile ? '2.5em': '3em'}}>{!this.state.playing ? '►' : '❚❚'}</span>
        </button>
        <div style={{width : isMobile ? `155px` : '400px', position : 'relative', left : '-5px'}}>
        <div style={{overflow : 'hidden',height : isMobile ? '30px' :'45px',position : 'relative',top : isMobile ? '-30px' : '-38px',left : isMobile ? '45px' : '50px'}}class="waveform "id={`waveform${this.props.id}`} />
        </div>
       
        <div style={{ color : 'white',position : 'relative', top : isMobile ? '-40px ':'-45px', left :isMobile ?'196px':'450px'}}>►{this.props.plays}</div>
        <audio id={`track${this.props.id}`} src={this.props.url} />
        { this.state.hasStarted ? <div style={{ color : 'white', width : '30px',zIndex : '30', position : 'relative', left : isMobile ?'196px':'450px', top : '-88px'}}>{Math.floor(this.state.current / 60) + ':' + ('0'+Math.floor(this.state.current % 60)).slice(-2)}</div> : ''}
        <div id={`volumeSlider${this.props.id}`} class="volume"  style={{ color : 'white', visibility : !this.state.playing || isMobile ? 'hidden' : '',position : 'relative',Left : isMobile ? '-50px' : '0px'}}>
              <i
                class=" ui volume down icon" id={`volumeIcon${this.props.id}`} style={{zIndex : '1000', position : 'relative',top : '-84px',left : isMobile ?'50px': '280px',color : 'white'
                  
                  }}
              />
              <input style={{backgroundColor : '#'+this.props.color,position : 'relative',left : isMobile ?'0px': '280px',}}
                id="volumeSlider"
                class="volume-slider"
                type="range"
                name="volume-slider"
                min="0"
                max="100"
                defaultValue="100"
              />
            </div>
      </div>
    );
  }
};

export default Waveform;
